import _ from 'lodash';

const moneyUtils = {
  currencyToCode(currency) {
    switch (currency.toLowerCase()) {
      case 'jpy':
        return '¥';
      case 'ntd':
      case 'twd':
        return 'NT$';
      case 'brl':
        return 'US$';
      default:
        return '$';
    }
  },
  paypalLocaleToCurrency(locale) {
    let currency = 'USD';
    switch (locale) {
      case 'ja':
        currency = 'JPY';
        break;
      case 'tw':
        currency = 'NTD';
        break;
    }
    return currency;
  },
  stripeCountryToCurrency(stripeCountryCode) {
    switch (stripeCountryCode.toUpperCase()) {
      case 'JP':
        return 'JPY';
      case 'TW':
        return 'NTD';
      default:
        return 'USD';
    }
  },
  stripeCountryToCurrencyCode(stripeCountryCode) {
    switch (stripeCountryCode.toUpperCase()) {
      case 'JP':
        return '¥';
      case 'TW':
        return 'NT$';
      case 'BR':
        return 'US$';
      default:
        return '$';
    }
  },
  getPrice(prices, currency) {
    let price;
    price = _.findLast(prices, (p) => {
      return p.currency_code === currency && p.is_active === true;
    });
    return price;
  },
};

export default moneyUtils;
